/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_compound_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is compound interest?`)
};

const es_sip_compound_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es el interés compuesto?`)
};

const de_sip_compound_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist Zinseszins?`)
};

const nl_sip_compound_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is samengestelde rente?`)
};

const fr_sip_compound_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que l'intérêt composé ?`)
};

const it_sip_compound_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è l'interesse composto?`)
};

const pt_br2_sip_compound_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é juros compostos?`)
};

const pt_sip_compound_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é juro composto?`)
};

const ja_sip_compound_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複利とは何ですか？`)
};

const zh_sip_compound_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是复利？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_compound_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_compound_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_compound_faq1_q", locale)
	if (locale === "en") return en_sip_compound_faq1_q(inputs)
	if (locale === "es") return es_sip_compound_faq1_q(inputs)
	if (locale === "de") return de_sip_compound_faq1_q(inputs)
	if (locale === "nl") return nl_sip_compound_faq1_q(inputs)
	if (locale === "fr") return fr_sip_compound_faq1_q(inputs)
	if (locale === "it") return it_sip_compound_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_compound_faq1_q(inputs)
	if (locale === "pt") return pt_sip_compound_faq1_q(inputs)
	if (locale === "ja") return ja_sip_compound_faq1_q(inputs)
	return zh_sip_compound_faq1_q(inputs)
};